import Swiper from 'swiper';
const CardCarousel = {

    init() {
        this._sliderEl = $('.jsSwiper.jsCardCarousel');
        if (this._sliderEl.length > 0) {
            this.initSlider();
            this.addEvents();
        }

    },
    addEvents() {
        if (this._sliderEl.find('.jsReadToggle').length > 0) {
            this._sliderEl.find('.jsReadToggle').on('click', function(e) {
                e.preventDefault();
                let jTarget = $(e.delegateTarget);
                const bReadState = jTarget.data('read-state');
                jTarget.closest('.jsReadContainer').find('.jsReadContent').hide();
                if (bReadState) {
                    $(jTarget.data('more-target')).show();
                    jTarget.text(jTarget.data('label-read-more'));
                } else {
                    $(jTarget.data('less-target')).show();
                    jTarget.text(jTarget.data('label-read-less'));
                }

                jTarget.closest('.jsReadContainer').find('.card-carousal__arrow').toggleClass('card-carousal__arrow_down');

                jTarget.data('read-state', !bReadState);

            });
        }
    },
    initSlider() {
        // Card Carousel Swipers
        if ($('.jsSwiper.jsCardCarousel').length > 0) {
            new Swiper($('.jsSwiper.jsCardCarousel')[0], {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }

    },
}
export default CardCarousel;


// WEBPACK FOOTER //
// ./scripts/modules/components/_card-carousel.js